// extracted by mini-css-extract-plugin
export var cardIcon = "_9x-5";
export var cardIconUnframed = "_9x-9";
export var checkboxCard = "_9x-0";
export var checkboxCardSelected = "_9x-4";
export var disabled = "_9x-2";
export var interactive = "_9x-1";
export var outerBorder = "_9x-3";
export var spacerMedium = "_9x-8";
export var spacerSmall = "_9x-7";
export var spacerXsmall = "_9x-6";